import { getCookies } from "commons/cookies/cookiesHook";
import Http, { HttpLogin } from "commons/Http";
import { CookieName } from "store/storageVo";
import { HttpNode } from "./Http";

Http.interceptors.request.use(
  async axiosconfig => {
    const isAllowPath = ["/"].includes(location.pathname);
    const token = await getCookies(CookieName.AUTH);
    // axiosconfig.headers = {};

    if (token === undefined && !isAllowPath) {
      const refresh = await getCookies(CookieName.REFRESH);
      if (refresh !== undefined) {
        if (axiosconfig.headers) {
          axiosconfig.headers.Authorization = `Bearer ${refresh}`;
        }
      } else {
        //TODO: 토큰정보가 진짜 없을때 어디로 가야하오..
        console.log("토큰정보 진짜없음");
      }
    } else {
      if (axiosconfig.headers) {
        axiosconfig.headers.Authorization = `Bearer ${token}`;
      }
    }
    axiosconfig.url = axiosconfig.url + "";
    return axiosconfig;
  },
  error => {
    return Promise.reject(error);
  },
);
Http.interceptors.response.use(async response => {
  const isAllowPath = ["/"].includes(location.pathname);
  if (response.data.code === 401 && !isAllowPath) {
    throw Error;
  }
  return response;
});

HttpLogin.interceptors.request.use(
  async axiosconfig => {
    const isAllowPath = ["/"].includes(location.pathname);
    const token = await getCookies(CookieName.AUTH);
    // axiosconfig.headers = {};
    if (token === undefined && !isAllowPath) {
      const refresh = await getCookies(CookieName.REFRESH);
      if (refresh !== undefined) {
        if (axiosconfig.headers) {
          axiosconfig.headers.Authorization = `Bearer ${refresh}`;
        }
      } else {
        // console.log("main going");
      }
    } else {
      if (axiosconfig.headers) {
        axiosconfig.headers.Authorization = `Bearer ${token}`;
      }
    }
    axiosconfig.url = axiosconfig.url + "";
    return axiosconfig;
  },
  error => {
    return Promise.reject(error);
  },
);
HttpLogin.interceptors.response.use(async response => {
  const isAllowPath = ["/"].includes(location.pathname);
  if (response.data.code === 401 && !isAllowPath) {
    throw Error;
  }
  return response;
});

HttpNode.interceptors.request.use(
  async axiosconfig => {
    const isAllowPath = ["/"].includes(location.pathname);
    const token = await getCookies(CookieName.AUTH);
    // axiosconfig.headers = {};
    if (token === undefined && !isAllowPath) {
      const refresh = await getCookies(CookieName.REFRESH);
      if (refresh !== undefined) {
        if (axiosconfig.headers) {
          axiosconfig.headers.Authorization = `Bearer ${refresh}`;
        }
      }
    } else {
      if (axiosconfig.headers) {
        axiosconfig.headers.Authorization = `Bearer ${token}`;
      }
    }
    axiosconfig.url = axiosconfig.url + "";
    return axiosconfig;
  },
  error => {
    return Promise.reject(error);
  },
);
HttpNode.interceptors.response.use(async response => {
  const isAllowPath = ["/"].includes(location.pathname);
  if (response.data.code === 401 && !isAllowPath) {
    throw Error;
  }
  return response;
});
